<template>
  <Transition name="slide-fade">
    <div
      v-if="isDropdownOpen.sidebar"
      class="navigation"
    >
      <div class="navigation__scroll-wrapper">
        <div class="navigation__wrapper">
          <!-- <WelcomeBonus class="navigation__welcome" /> -->
          <ClientOnly>
            <ProfileBlock class="navigation__profile" />
          </ClientOnly>
          <MenuNav class="navigation__menu-nav" />
          <NavInfo class="navigation__nav-info" />
          <SocialBlock v-if="!$device.isMobile" class="navigation__social" />
          <button class="navigation__search-button" type="button" @click="openSearchForm">
            <SvgIcon name="navigation/search-normal" class="navigation__search-icon" />
            <UiText
              font="body-text-small"
              color="typography-body01"
              class="navigation__search-text"
              :text="$tc('lobby.search.input')"
            />
          </button>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import MenuNav from '@/components/App/AppBurgerMenu/MenuNav'
import NavInfo from '@/components/App/AppBurgerMenu/NavInfo'
import WelcomeBonus from '@/components/App/AppBurgerMenu/WelcomeBonus'
import ProfileBlock from '@/components/App/AppBurgerMenu/ProfileBlock'
import SocialBlock from '@/components/App/AppBurgerMenu/SocialBlock'

export default {
  name: 'AppBurgerMenu',
  components: {
    SocialBlock,
    ProfileBlock,
    WelcomeBonus,
    MenuNav,
    NavInfo,
  },
  data() {
    return {
      isToggleTopPromo: true,
    }
  },
  computed: {
    ...mapGetters('base', ['isDropdownOpen']),
    ...mapGetters('user', ['isLoggedIn', 'isUserVerified']),
    ...mapGetters('limits', ['get_isLimitsHasBeenSet']),
  },
  watch: {
    '$route.fullPath'() {
      this.closeDropdown()
    },
  },
  beforeDestroy() {
    this.closeDropdown() // when leaving layout
  },
  methods: {
    ...mapActions('base', ['closeDropdown']),
    ...mapActions('lobby', ['toggle_openSearch']),
    openSearchForm() {
      this.closeDropdown()
      this.toggle_openSearch(true)
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
